<!-- 汇率查询 -->
<template>
  <div class="exchangerate">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar>
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#00b400' : '#00b400') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#00b400' : '#00b400')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              ><svg-icon
                v-if="item.attributes.buttonStyle"
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                :icon-class="item.attributes.buttonStyle"
              />{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="loading"
        :edit-actived="activeIndex"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="rules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @cell-click="getActiveIndex"
        @select-change="handleSelectionChange"
        :max-height="$store.state.app.tableHeight"
        @select-all="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <!-- 币种 自 -->
        <vxe-table-column
          field="fromCurrencyCode"
          :title="$t('exchangerate.label.fromCurrencyCode')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              v-model="scope.row.fromCurrencyCode"
              @change="fromCurrencyCodeChange(scope)"
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="scope">{{
            getSelectLabel(scope.row.fromCurrencyCode, currencyList)
          }}</template>
        </vxe-table-column>
        <!-- 币种 至 -->
        <vxe-table-column
          field="toCurrencyCode"
          :title="$t('exchangerate.label.toCurrencyCode')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              v-model="scope.row.toCurrencyCode"
              @change="toCurrencyCodeChange(scope)"
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="scope">{{
            getSelectLabel(scope.row.toCurrencyCode, currencyList)
          }}</template>
        </vxe-table-column>
        <!-- 日期 -->
        <vxe-table-column
          field="exchangeDate"
          :title="$t('exchangerate.label.exchangeDate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              clearable
              type="date"
              value-format="yyyy-MM-dd"
              v-model="scope.row.exchangeDate"
            ></el-date-picker>
          </template>
          <template v-slot="scope">{{ formatDate(scope.row.exchangeDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <!-- 汇率类型 -->
        <vxe-table-column
          field="exchangeType"
          :title="$t('exchangerate.label.exchangeType')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              v-model="scope.row.exchangeType"
              @change="$refs.table.updateStatus(scope)"
            >
              <el-option
                v-for="item in exchangeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="scope">{{
            getSelectLabel(scope.row.exchangeType, exchangeTypeList)
          }}</template>
        </vxe-table-column>
        <!-- 币种自->币种至 -->
        <vxe-table-column
          field="positiveRate"
          :title="$t('exchangerate.label.positiveRate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-input-number
              style="width: 100%"
              :precision="$globalVar.ePiont"
              :controls="false"
              :min="0"
              v-model="row.positiveRate"
              @change="positiveRateChange(row.positiveRate, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <!-- 币种至->币种自 -->
        <vxe-table-column
          field="negativeRate"
          :title="$t('exchangerate.label.negativeRate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-input-number
              style="width: 100%"
              :precision="$globalVar.ePiont"
              :controls="false"
              :min="0"
              v-model="row.negativeRate"
              @change="negativeRateChange(row.negativeRate, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  import { tableRules } from './rules.js'; // 校验规则
  import API from '@/api/financeCenter/exchangerate';
  import SiruiSearch from '@/components/SiruiSearch';
  import XEUtils from 'xe-utils';
  export default {
    name: 'exchangeRate',
    components: {
      SiruiSearch,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            name: this.$t('exchangerate.label.fromCurrencyCode'),
            prop: 'fromCurrencyCode',
            type: 'select',
            options: this.currencyList,
          },
          {
            name: this.$t('exchangerate.label.toCurrencyCode'),
            prop: 'toCurrencyCode',
            type: 'select',
            options: this.currencyList,
          },
          {
            name: this.$t('exchangerate.label.searchStartTime'),
            prop: 'startTime',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('exchangerate.label.searchEndTime'),
            prop: 'endTime',
            type: 'endDaterangePicker',
          },
          {
            name: this.$t('exchangerate.label.exchangeType'),
            prop: 'exchangeType',
            type: 'select',
            options: this.exchangeTypeList,
          },
        ];
      },
    },
    data() {
      return {
        activeIndex: '', // 激活行索引
        menuButtonList: [], // 按钮
        loading: false,
        tableData: [],
        multipleSelection: [],
        currencyList: [], // 货币数据
        exchangeTypeList: [], // 汇率类型
        searchForm: {
          // 搜索条件
          fromCurrencyCode: '',
          toCurrencyCode: '',
          exchangeType: '',
          startTime: '',
          endTime: '',
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: tableRules,
        heightNew: 0,
      };
    },
    mounted() {
      this.resolveTime(); // 设置默认时间
      this.getData();
      this.getButtonList();
      this.getDictList();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      getData() {
        const { tenantCode, companyCode, departmentCode } = this.userInfo;
        const obj = { tenantCode, companyCode, departmentCode };
        const params = Object.assign(JSON.parse(JSON.stringify(this.searchForm)), obj);
        params.pageSize = this.page.pageSize;
        params.pageNum = this.page.pageNum;
        this.$axios.post(API.EXCHANGERATE_LIST, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.page.total = res.data.data.total;
          }
        });
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value === 'del') {
          this.handleDel();
        }
      },
      // 跳转至新增页面
      handleAdd() {
        let path = {
          path: '/generalAccounting/exchangerateMaintain',
          name: 'exchangerateMaintain',
          meta: {
            keepAlive: true,
            title: this.$t('exchangerate.router.exchangerateMaintain'),
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.select'),
            type: 'error',
          });
        }
      },
      // 币种自改变
      fromCurrencyCodeChange(scope) {
        this.$refs.table.updateStatus(scope);
        let { fromCurrencyCode, toCurrencyCode } = this.tableData[scope.rowIndex];
        if (toCurrencyCode && fromCurrencyCode == toCurrencyCode) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.repeat'),
            type: 'error',
          });
          this.tableData[scope.rowIndex].fromCurrencyCode = '';
        }
      },
      // 币种至改变·
      toCurrencyCodeChange(scope) {
        this.$refs.table.updateStatus(scope);
        let { fromCurrencyCode, toCurrencyCode } = this.tableData[scope.rowIndex];
        if (fromCurrencyCode && toCurrencyCode == fromCurrencyCode) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.repeat'),
            type: 'error',
          });
          this.tableData[scope.rowIndex].toCurrencyCode = '';
        }
      },
      // 正向汇率改变
      positiveRateChange(value, index) {
        this.tableData[index].negativeRate = 1 / value;
      },
      // 逆向汇率改变
      negativeRateChange(value, index) {
        this.tableData[index].positiveRate = 1 / value;
      },
      // 保存
      handleSave() {
        if (this.tableData.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.no_Data'),
            type: 'error',
          });
          return;
        }
        this.$refs.table.validate((valid) => {
          if (valid) {
            const createBy = this.userInfo.userCode;
            const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
              this.userInfo;
            const currencyExchangeString = JSON.stringify(this.tableData);
            const params = {
              createBy,
              currencyExchangeString,
              tenantCode,
              companyCode,
              departmentCode,
              companyName,
              departmentName,
            };
            this.$axios.post(API.UPDATE_CURRENCY_EXCHANGE, params).then((res) => {
              if (res.data.code === 0) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.getData();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('exchangerate.message.please_complete_form_data'),
              type: 'error',
            });
          }
        });
      },
      // 删除
      handleDel() {},
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      // 设置默认时间
      resolveTime() {
        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        this.searchForm.startTime = `${year}-${month}-01`;
        this.searchForm.endTime = dateFormat(new Date());
      },
      search() {
        if (this.searchForm.startTime == '' || this.searchForm.startTime == null) {
          return this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.startTime'),
            type: 'error',
          });
        }
        if (this.searchForm.endTime == '' || this.searchForm.endTime == null) {
          return this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.endTime'),
            type: 'error',
          });
        }
        this.getData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.table.clearCheckboxReserve();
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.resolveTime();
        this.getData();
      },
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 币种
        this.$axios.get(API.LIST_CURRENCY).then((res) => {
          if (res.data.code === 0) {
            this.currencyList = [];
            res.data.data.forEach((item) => {
              let obj = {
                label: item.currencyName,
                value: item.currencyCode,
              };
              this.currencyList.push(obj);
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 汇率类型
        this.$axios.post(API.DICT_LIST, { dictType: 'exchange_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.exchangeTypeList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
    },
  };
</script>
<style>
  .exchangerate .vxe-table.vxe-editable.size--mini .vxe-body--column {
    height: 36px;
  }
</style>
<style scoped>
  .exchangerate .pagination {
    text-align: right;
    margin: 10px 0;
  }
</style>
